import {Combo, ComboConstructor} from '@mintdata-wsp/common/components/combo/Combo';
import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {Organization} from '@mintdata-wsp/common/state/DataState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {PublishMode} from '@mintdata-wsp/common/state/ui/publish/PublishState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {IList, IListItemState, ListModel} from '@mintdata/mint-kit/api/models/List';
import {IStyles} from '@mintdata/mint-kit/impl/util/Styles';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {computed} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('@mintdata-wsp/wsp/ui/dialogs/publish/AccessModeDropdown.less');
const cx = classnames.bind(styles);

export interface IAccessModeDropdownProps
{
    className?:string;
}

export interface IAccessModeItem
{
    value:PublishMode;
    label:string;
    description:string;
}

@observer
export class AccessModeDropdown extends React.Component<IAccessModeDropdownProps, any>
{
    @computed
    private get _accessModeItems():IList<IAccessModeItem>
    {
        return AccessModeDropdown._computeListModel(
            rootState.userSession.currentOrganization,
            rootState.ui.publish.request.mode
        );
    }

    @bind
    private _onItemSelected(item:IAccessModeItem):void
    {
        controllers.ui.publish.setPublishMode(item.value);
    }

    public render():JSX.Element
    {
        const AccessCombo:ComboConstructor<IAccessModeItem> = Combo as any;

        return <AccessCombo
            dataSource={this._accessModeItems}
            itemRenderer={AccessModeDropdown._renderItem}
            onSelectItem={this._onItemSelected}
            theme={styles}
            className={cx('combo')}
        />;
    }

    private static _renderItem(item:IAccessModeItem, state:IListItemState, styles:IStyles):JSX.Element
    {
        const {isSelected} = state;

        return <Row className={cx('comboItem', {isSelected})}>
            <MDIcon
                className={styles.accessModeIcon}
                name={isSelected ? MDIcons.common.RadioChecked : MDIcons.common.Radio}
                size={MDIconSize.medium}
            />
            <Column>
                <span className={styles.title}>{item.label}</span>
                <span className={styles.description}>{item.description}</span>
            </Column>
        </Row>;
    }

    private static _computeListModel(currentOrg:Organization, selectedMode:PublishMode):IList<IAccessModeItem>
    {
        const listModel:IList<IAccessModeItem> = new ListModel<IAccessModeItem>(
            [
                {
                    value: PublishMode.Public,
                    label: 'Public Access',
                    description: 'Everyone can access the application'
                },
                {
                    value: PublishMode.UniqueLink,
                    label: 'Anyone with the link can access',
                    description: 'Anyone with the link can access the application'
                },
                // {
                //     value: PublishMode.MintDataLogin,
                //     label: 'Any MintData user',
                //     description: 'A MintData login is required to access the application'
                // },
                {
                    value: PublishMode.MintDataOrganizationLogin,
                    label: `Only MintData users from ${currentOrg.name} (${currentOrg.siteId})`,
                    description: `Only members of ${currentOrg.name} can access the application`
                },
                // {
                //     value: PublishMode.CorporateSSO,
                //     label: 'Your current corporate login (single sign-on)',
                //     description: 'A deep integration with your existing corporate identity system'
                // }
            ]
        );

        listModel.selectByValueProperty(selectedMode, 'value');

        return listModel;
    }
}
